module.exports = __webpack_public_path__ + "img/img_serve_01@2x.dc7bc421.png";